import initialState from './initialState';
import { FETCH_ARTICLEGROUPS, RECEIVE_ARTICLEGROUPS } from '../actions/actionTypes';

export default function articleGroupsReducer(state = initialState.articleGroups, action) {
	let newState = {};
	switch (action.type) {
		case FETCH_ARTICLEGROUPS:
			return { ...state, fetching: true };
		case RECEIVE_ARTICLEGROUPS:
			newState.items = action.articleGroups.items;
			newState.pagination = action.articleGroups.pagination;
			newState.pagination.pageSizeOptions = state.pagination.pageSizeOptions;
			newState.search = action.articleGroups.search;
			newState.fetching = false;
			return newState;
		default:
			return state;
	}
}